import { fetchPost } from 'services/http';

export const trackEvent = (eventName, extraData = null) => {
  return fetchPost('/track', {
    eventName,
    time: Date.now(),
    extraData: extraData || {}
  });
};
